module.exports = __webpack_public_path__ + "media/images/common/kuchi_01-69381e33132a9f1a5c32c237e3f2c763.gif";